import React from 'react'
import styled, { useTheme } from 'styled-components'
import CMS from '@talus-analytics/library.airtable-cms'
import Carousel from '@talus-analytics/library.ui.carousel'

import useCarouselResources from 'dataHooks/useCarouselResources'
import { Main } from 'components/layout'
import { Tags } from 'components/ui'
import { useLandingPageData } from 'cmsHooks'

import { truncateDescription, displayOwner } from 'utilities/language'
import TemplateLink from 'components/navigation/TemplateLink'
import device from 'utilities/device'

const Header = styled.h1`
  text-align: center;
`
const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const CarouselBackground = styled.div`
  max-width: 1040px;
`
const StyledCarousel = styled(Carousel)`
  margin-top: 3rem;
  margin-bottom: 2.5rem;
  > div:first-child {
    button {
      &:hover {
        background-color: ${({ theme }) => theme.callToActionAlternate};
      }
    }
  }
  @media ${device.mobileM} {
    div {
      &:first-child {
        > button {
          margin-right: 10px;
        }
      }
    }
    div {
      &:last-child {
        > button {
          &:not(:last-of-type) {
            left: -25px;
          }
          &:last-of-type {
            right: -25px;
          }
        }
      }
    }
  }
`
const Card = styled.div`
  position: relative;
  height: 100%;
  background-color: ${({ theme }) => theme.background};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  padding: 30px 40px;
  min-height: 290px;
  max-width: 820px;
  @media ${device.mobileM} {
    padding: 20px;
  }
`
const TextContent = styled.p`
  margin-bottom: 1rem;
`
const Title = styled(TemplateLink)`
  ${({ theme }) => theme.textStyleH3}
`
const Author = styled.p`
  margin-top: 0.5rem;
  ${({ theme }) => theme.textStyleH5}
  color: ${({ theme }) => theme.neutral1};
  max-width: 90%;
`
const Description = styled.p`
  ${({ theme }) => theme.textStyleMedParagraph}
  color: ${({ theme }) => theme.text};
  margin-top: 1.5rem;
`

const CarouselSection = (): JSX.Element => {
  const carouselResources = useCarouselResources()
  const landingPageContent = useLandingPageData()
  const theme: any = useTheme()

  return (
    <Container>
      <CarouselBackground>
        <Header>
          <CMS.Text name="Second header alternate" data={landingPageContent} />
        </Header>
        <Main>
          <StyledCarousel
            buttonColor={theme.callToAction}
            disabledButtonColor={theme.special3}
          >
            {carouselResources.nodes.map(({ data: resource }) => (
              <Card key={resource.Title}>
                <TextContent>
                  <Title data={resource} openInNewTab>
                    {resource.Title}
                  </Title>
                  <Author>{displayOwner(resource.Owner)}</Author>
                  <Description>
                    {truncateDescription(resource, resource.Description, 40)}
                  </Description>
                </TextContent>
                {resource.Tags && <Tags tags={resource.Tags} />}
              </Card>
            ))}
          </StyledCarousel>
        </Main>
      </CarouselBackground>
    </Container>
  )
}

export default CarouselSection
